import type { TransactionDetail } from '@/api/useFreight/types'
import { PopconfirmButton } from '@/components/_SiteWide/PopconfirmButton'
import { AccessorialForm } from '@/components/Freight/FreightLineItems/components/AddFreightLineItem/components/AccessorialForm'
import { AccessorialFormType } from '@/components/Freight/FreightLineItems/components/AddFreightLineItem/types'
import { EditOutlined } from '@ant-design/icons'
import { Horizontal, GraviButton } from '@gravitate-js/excalibrr'
import { Popover } from 'antd'
import { useForm } from 'antd/es/form/Form'
import { useMemo, useState } from 'react'
import { getLocationsFromOrder } from './utils'

type ActionCellRendererProps = {
  handleSave: (formValues: AccessorialFormType, accessorial: TransactionDetail) => void
  data: TransactionDetail
  isOverridePending?: boolean
  order: Gravitate.Order
}

export function ActionCellRenderer({ handleSave, data, isOverridePending, order }: ActionCellRendererProps) {
  const [open, setOpen] = useState(false)

  return (
    <Horizontal gap={4}>
      <Popover
        content={
          <EditPopoverContent
            handleSave={handleSave}
            handleClose={() => setOpen(false)}
            data={data}
            isOverridePending={isOverridePending}
            order={order}
          />
        }
        title='Edit Accessorial'
        trigger='click'
        open={open}
        destroyTooltipOnHide
        onOpenChange={(visible) => setOpen(visible)}
        styles={{ root: { width: 400 } }}
      >
        <GraviButton
          size='small'
          icon={<EditOutlined />}
          onClick={() => setOpen(true)}
          loading={isOverridePending}
          disabled={!data.can_edit}
        />
      </Popover>

      {/* DELETE FUNCTIONALITY WAS MOVED TO A FUTURE TICKET, LEAVING THIS HERE FOR LATER */}
      {/* {params.data.manual && params.data.id && (
        <Tooltip title='Delete'>
          <PopconfirmButton
            onConfirm={() => onDelete(params)}
            buttonProps={{
              className: 'ml-1',
              size: 'small',
              appearance: 'outline',
              icon: <MaterialIcon icon='delete' size={16} />,
            }}
            popconfirmProps={{
              title: 'Are you sure you want to delete this accessorial?',
              okText: 'Yes',
              cancelText: 'No',
              placement: 'topRight',
            }}
          />
        </Tooltip>
      )} */}
    </Horizontal>
  )
}

function EditPopoverContent({
  handleSave,
  handleClose,
  data,
  order,
}: ActionCellRendererProps & { handleClose: () => void }) {
  const [form] = useForm<AccessorialFormType>()

  const initialValues = useMemo(
    () => ({
      amount: data.amount,
      origin: data.origin_name ? { label: data.origin_name, value: data.origin_id } : null,
      destination: data.destination_name ? { label: data.destination_name, value: data.destination_id } : null,
    }),
    [data]
  )

  function handleSubmit() {
    handleSave(form.getFieldsValue(), data)
    handleClose()
  }
  const locationOptions = useMemo(() => getLocationsFromOrder(order), [order])

  return (
    <AccessorialForm
      form={form}
      initialValues={initialValues}
      terminalOptions={locationOptions}
      storeOptions={[]}
      onFinish={handleSubmit}
      onReset={handleClose}
      groupLocations={false}
      showRateAndTotal={false}
      currentAccessorial={data}
    />
  )
}
